import DTRBIIssueLoyaltyPointsAndRefundThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTRBIIssueLoyaltyPointsAndRefundThenSendMacroNode/DTRBIIssueLoyaltyPointsAndRefundThenSendMacroNode';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';

const RbiIssueLoyaltyPointsAndRefundThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRBIIssueLoyaltyPointsAndRefundThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'Loyalty points have been issued and the refund has been processed.'}
    />
  );
};

export default RbiIssueLoyaltyPointsAndRefundThenSendMacro;
